import React from 'react';
import { Link, LinkProps } from 'react-router-dom';
import { scrollToTop } from '../hooks/useScrollToTop';

interface SmoothLinkProps extends Omit<LinkProps, 'onClick'> {
  onClick?: (event: React.MouseEvent<HTMLAnchorElement>) => void;
}

const SmoothLink: React.FC<SmoothLinkProps> = ({ onClick, to, ...props }) => {
  const handleClick = (event: React.MouseEvent<HTMLAnchorElement>) => {
    if (onClick) {
      onClick(event);
    }
    if (typeof to === 'string' && to.includes('#')) {
      event.preventDefault();
      const hash = to.split('#')[1];
      const el = document.getElementById(hash);
      if (el) {
        el.scrollIntoView({ behavior: 'smooth' });
        // Also update the URL hash without reloading
        window.history.pushState(null, '', `#${hash}`);
      } else {
        scrollToTop();
      }
    } else {
      scrollToTop();
    }
  };

  return <Link {...props} to={to} onClick={handleClick} />;
};

export default SmoothLink; 